export default "__VITE_ASSET__6zJtHLbR__"